import React, {Component} from 'react';
import PropTypes from 'prop-types'
import $ from 'jquery';
import 'fullcalendar';
import '../../../assets/css/fullcalendar.min.css'
import FullCalendar from 'fullcalendar-reactwrapper';
import {Link} from 'react-router-dom'
import Modal from 'react-modal'
import CutoffDays from './cutoffDays';
import {MONTH,currency_symbol,URL_VERSION, MealTypes, MenuOrderTypes} from "../../../server/constants";
import {BeatLoader} from 'react-spinners';
import NotificationSystem from 'react-notification-system';
import Datetime from 'react-datetime'
import {postWithHeaders,postWithHeadersResponse} from '../../../server/actions'
import '../../../../node_modules/react-datetime/css/react-datetime.css'
import {formatDate, gradeNoToText, isWeekMenu, isRegularLunchOrderType, groupBy, getNotWorkingDays, convertTwoDecimalPoint} from '../../../server/util'
import moment from  'moment';
let converter = require('number-to-words');

let userInfo = '';
let mealMenu = {};
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};

Date.prototype.addHours = function (h) {
    this.setHours(this.getHours() + h);
    return this;
};


class fullcalendar extends Component {
    componentWillMount = () => {
        //  alert(JSON.stringify(this.props.meals,null,2))
        userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        //alert(userInfo.schoolName)
        try {
            this.props.meals.mealMenuItems.forEach(event => {

                if (event.type === "SIDE") {
                    event.start = event.start.addHours(1);

                }
                 if (event.type === "EXTRA"){
                    event.start = event.start.addHours(2);
                }
            });
            this.setState({meals: this.props.meals.mealMenuItems});
            console.log(this.props.meals)
        } catch (err) {
            console.log("No meals for this month", +err)
        }
    }
    cutOffChange = (e) => {
        this.setState({cutOffDateTime: new Date(e)})
    };


    constructor(props) {
        super(props);
        this.state = {
            cutOffDateTime: '',
            meals: [],
            loading: false,
            modalIsOpen: false,
            cutOffObj:this.props.mealObject
        }
        this.updateEvents = this.updateEvents.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.renderInput=this.renderInput.bind(this);
        this.eventRender=this.eventRender.bind(this);
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    componentDidMount() {
        //this.updateEvents(this.state.meals);
        this._notificationSystem = this.refs.notificationSystem;
    }

    componentDidUpdate() {
        //this.updateEvents(this.state.meals);
    }
    

    updateEvents(eventsList) {
        //console.log(eventsList);
        try{
        $('#calendar').fullCalendar('destroy');
        $('#calendar').fullCalendar({
            defaultDate: new Date(this.props.date.year, this.props.date.month - 1, 1),
            themeSystem: 'bootstrap3',
            disableDragging: true,
            height: 'auto',
            header: false,
            weekends: false,
            events: eventsList,
            displayEventTime: false,
            editable: false,
            fixedWeekCount: false,
            droppable: false, // this allows things to be dropped onto the calendar
            eventRender: function (event, element, view) {
                var dataHoje = new Date();
                if (event.type === "MEAL" || event.type === MealTypes.SNACK.toUpperCase()
                // || event.type === MenuOrderTypes.ITEMIZE.toUpperCase()) {
                ){
                    return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                        'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                        + event.title + "  " + currency_symbol() + event.price + '</div>');
                    //event.color = "#FFB347"; //Em andamento
                }
                else if (event.type === "SIDE") {
                    event.start = event.start + (1 * 60 * 60 * 1000);
                    element.css('background-color', 'inherit');
                    element.css('border', '0px');
                    element.css('font-weight', 'bolder');
                    element.css('white-space', 'pre-wrap');
                    element.css('color', 'red');
                    element.css('font-size', '12px');
                    element.css(' margin-bottom', '-5px');
                }
               /*  else if (event.type === "EXTRA"){
                    return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                    'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                    + event.title + "  " + currency_symbol() + event.price + '</div>');
                } */
            },
        })
    }
    catch(ex){

    }

    }

    _addNotification(event) {
        this._notificationSystem.addNotification({
            title: "Success",
            message: event,
            level: 'success',
            position: 'tc',
            autoDismiss: '3',
            uid: 5,

        });
    }

    _addNotificationError(event) {
        this._notificationSystem.addNotification({
            title: "Failed",
            message: event,
            level: 'error',
            position: 'tc',
            autoDismiss: '3',
            uid: 5,
        });
    }
    eventRender(event, element, view) {
        if (event.type === "MEAL" || event.type === MealTypes.SNACK.toUpperCase()) {
            return $('<div style="margin:2px 5px;background-color: inherit;border: 0px;' +
                'white-space: pre-wrap;color: black;font-size: 13px;font-weight: bolder">'
                + event.title + "  " + currency_symbol() + convertTwoDecimalPoint(event.price) + '</div>');
        }
        else if (event.type === "SIDE") {
            <div className="sectionTitle">
            <h5 style={{fontFamily: 'Dosis,sans-serif',color: 'rgb(234, 112, 102)',fontWeight: '700'}}><span>Sides</span></h5>
             </div>
            return $('<div style="margin:2px 5px;color: red;background-color: inherit;border: 0px;' +
            'white-space: pre-wrap;font-size: 12px;font-weight: bolder">' + 'S:' + "  " 
            + event.title  + '</div>');
           /*  event.start = event.start + (1 * 60 * 60 * 1000);
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', 'red');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px'); */
        }
        else if (event.type === "EXTRA" || event.type === MealTypes.SNACK.toUpperCase()) {
            
            return $('<div style="margin:2px 5px;color: red;background-color: inherit;border: 0px;' +
            'white-space: pre-wrap;color: #5cb85c;font-size: 12px;font-weight: bolder">'+'E:' + "  " 
            + event.title + "  " + currency_symbol() + event.price + '</div>');
           /*  event.start = event.start + (1 * 60 * 60 * 1000);
            element.css('background-color', 'inherit');
            element.css('border', '0px');
            element.css('font-weight', 'bolder');
            element.css('white-space', 'pre-wrap');
            element.css('color', '#5cb85c');
            element.css('font-size', '12px');
            element.css(' margin-bottom', '-5px'); */
        }
    }

    handleCreate(cutOffObj) {
        this.setState({
            loading: true,
            modalIsOpen: false
        })
        let userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        let username = userInfo.username;
        mealMenu.loggedUser = username;
        let grades = [];
        this.props.selectedGrades.map(grade => {
            //alert(grade);
            grades.push(grade);
            //grades.push(gradeNoToText(grade));
        })
        //alert(grades)        
        mealMenu.itemPriceDisForMonthlyOrder=(this.props.mealObject||{}).itemPriceDisForMonthlyOrder||0.00
        mealMenu.reducedPriceStatus = this.props.meals.reducedPriceStatus;
        mealMenu.name=this.props.mealObject.name;
        mealMenu.gradesList = grades;
        mealMenu.mealSchoolId = sessionStorage.getItem('SchoolId');
        mealMenu.yearMonth = "" + this.props.date.year + (('0' + (this.props.date.month)).slice(-2));
        mealMenu.mealMenus = [];
        if(cutOffObj.cutOffType =='W'){
            mealMenu.cutOffType=cutOffObj.cutOffType;
            mealMenu.weeklyOrderCutOffDay=cutOffObj.weeklyOrderCutOffDay;
            mealMenu.weeklyOrderCutOffTime= moment(cutOffObj.weeklyOrderCutOffTime).format('HH:mm');
            mealMenu.allowOrderNDaysBefore=0
            mealMenu.cutOffDateTime = null;

        }else if(cutOffObj.cutOffType =='R'){
            mealMenu.cutOffType=cutOffObj.cutOffType;
            mealMenu.allowOrderNDaysBefore=cutOffObj.allowOrderNDaysBefore;
            mealMenu.weeklyOrderCutOffDay='';
            mealMenu.weeklyOrderCutOffTime=cutOffObj.allowOrderNDaysTimeBefore.format('HH:mm'); 
            mealMenu.cutOffDateTime = null;
        }else{
            let d1 = new Date(cutOffObj.cutOffDateTime);
            let d2 = new Date(cutOffObj.cutOffDateTime);
            mealMenu.orderDateExtensionStatus = cutOffObj.orderDateExtensionStatus;
            mealMenu.cutOffType='M';
            mealMenu.weeklyOrderCutOffDay='';  
            mealMenu.weeklyOrderCutOffTime='';           
            mealMenu.cutOffTzDateTime = moment(cutOffObj.cutOffDateTime).isValid()?moment(cutOffObj.cutOffDateTime).format('YYYY-MM-DD HH:mm:ss'):null;
            if (cutOffObj.autoReminderDate1) {
                mealMenu.autoReminderDate1 = formatDate(new Date(d1.setDate(d1.getDate() - 7)))
            }
            if (cutOffObj.autoReminderDate2) {
                mealMenu.autoReminderDate2 = formatDate(new Date(d2.setDate(d2.getDate() - 2)))
            }
        }
        mealMenu.isSideSelect= cutOffObj.isSideSelect;
        mealMenu.isExtraPreOrder = cutOffObj.isExtraPreOrder;
        mealMenu.extraEnableForCaterer=cutOffObj.extraEnableForCaterer;
        this.state.meals.forEach(mealItem => {
            let item = mealItem;
            delete item.id;
            delete item.end;
            if (item.type !== "HOLIDAY") {
                //alert(mealItem.type)
                item.mealImage = "";
                item.start = formatDate(new Date(item.start));
                mealMenu.mealMenus.push(item)
            } else {
                delete item.price;
                item.start = formatDate(new Date(item.start));
                mealMenu.mealMenus.push(item)
            }
        });
        //console.log(JSON.stringify(this.state.meals, null, 2))
        if ((((this.props.meals||{}).extra||[]).length||0) > 0) {
            //alert(JSON.stringify(this.props.meals.extra,null,2))
            this.props.meals.extra.forEach(item => {
                let extraItem = item;
                delete extraItem.id;
                delete extraItem.start;
                delete extraItem.end;
                mealMenu.mealMenus.push(extraItem)
            })
        }
        if(this.props.recId>0){
            mealMenu.schoolMealSummaryId=this.props.recId;
        }
        let headers = {
            'Content-Type': 'application/json'
        }
        //console.log("mealCreate:::::",JSON.stringify(mealMenu));
       // const mType=(this.props.type==MealTypes.LUNCH && !isRegularLunchOrderType())?MenuOrderTypes.ITEMIZE:this.props.type;
        postWithHeadersResponse(URL_VERSION+'/schoolMealsCreate?itemType='+this.props.type+'&access_token=', JSON.stringify(mealMenu), headers).then((response) => {
            if (response.statusCode == 200) {
                this.setState({loading: false});
                this._addNotification('Successfully Created Meal Menu.');

                setTimeout(() => {
                    this.context.router.history.push('/schoolAdmin/viewMenu')
                }, 3000);
                console.log('response', response);
            } else if (!response.ok) {
                throw Error(response.statusMessage);
            }
        }).catch(
            (error) => {
                this.setState({loading: false});
                this._addNotificationError(error.message);
                console.log('Meal Menu Creation Error', error.message)
            }
        );

    }


    render() {
        const gradeGroup=groupBy(this.props.schoolGrades,'value');
        return (
            <div>
                <section className="mainContent full-width clearfix">
                    <NotificationSystem ref="notificationSystem"/>
                    <div className='sweet-loading'
                         style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <button type="button" className="pull-right" data-dismiss="modal" onClick={() => {
                            this.setState({modalIsOpen: false})
                        }}>&times;</button>
                        <div className="row">
                            <h3 style={{color: '#0000b2'}} className="text-center">Cut-off Date</h3>
                            <form>
                                <div className="col-md-10 col-md-offset-1">
                                    <CutoffDays mealObj={this.state.cutOffObj} {...this} isWeekly={isWeekMenu(this.props.type)} onCutoffDateSubmit={(cutOffObj)=>{
                                        this.handleCreate(cutOffObj);
                                       // console.log(cutOffObj)
                                    }} />
                                </div>                                
                            </form>
                        </div>
                    </Modal>
                    <div id="print">
                        <div className="row">
                            <div className="col-xs-2">
                                <Link to="/schoolAdmin/createMenu"
                                      onClick={() => {
                                          this.props.back()
                                      }}
                                      className="btn btn-danger btn-sm pull-left " style={{margin: '0px'}}> Back</Link>
                            </div>
                            <div className="col-xs-8 text-center">
                                <h4 style={{
                                    textDecoration: 'underline',
                                    textDecorationColor: 'red',
                                    textDecorationSkip: '',
                                    color: '#0000b2',
                                    fontFamily: 'PT Serif'
                                }}>{userInfo.schoolName}</h4>
                            </div>
                            <div className="col-xs-2">
                                <button onClick={() => this.setState({modalIsOpen: true})}
                                        className="btn btn-success btn-sm pull-right "
                                        style={{margin: '0px'}}> Create
                                </button>
                            </div>
                        </div>
                        <div className="text-center"><h5
                            style={{margin: '0px'}}>{`${MONTH[this.props.date.month - 1]} ${this.props.date.year} - ${this.props.type}
                            Menu for Grades: ${(this.props.selectedGrades||[]).map(item=>{
                                return ((gradeGroup[item]||[])[0]||{}).name
                            }).join(", ")}
                        `}</h5></div>
                        {/* <div id='calendar'>
                        </div> */}
                        <div className="table-responsive">
                                <FullCalendar id='mCal'
                                    height="auto"
									//defaultView="listMonth"
                                    defaultDate={new Date(this.props.date.year, this.props.date.month - 1, 1)}
                                    themeSystem='bootstrap3'
                                    droppable={false}
                                    disableDragging={true}
                                    editable={false}
                                    header={false}
                                    hiddenDays={getNotWorkingDays()} 
                                    //weekends={false}
                                    resizable={false}
                                    events={this.state.meals}
                                    displayEventTime={false}
                                    fixedWeekCount={false}
                                    // droppable: true, // this allows things to be dropped onto the calendar
                                    eventRender={this.eventRender}
                                />

                            </div>
                            
                        <br/>
                        {
                            (((this.props.meals||{}).extra||[]).length||0) !== 0 ?
                                <div className="text-center">
                                    <i>
                                        <b>Below items are available for on-site purchase</b>
                                    </i>
                                    <div className="row">
                                        <table className="col-xs-offset-3 col-xs-6 " border="1"
                                               style={{height: 'auto', fontWeight: 'bolder'}}>
                                            <thead style={{backgroundColor: ' #ea7066', color: 'white'}}>
                                            <tr>
                                                <th style={{textAlign: 'center'}}>Item</th>
                                                <th style={{textAlign: 'center'}}>Price</th>
                                            </tr>
                                            </thead>
                                            <tbody align="center">
                                            {
                                                this.props.meals.extra.map(meal => {
                                                    if (meal.type === "EXTRA") {
                                                        return <tr>
                                                            <td align="center">{meal.title} </td>
                                                            <td align="center">{currency_symbol()+' '+meal.price} </td>
                                                        </tr>;
                                                    }
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                : ''}
                    </div>
                    <br/>
                    <br/>
                </section>
            </div>
        )
    }
}

fullcalendar.contextTypes = {
    router: PropTypes.object.isRequired
}

export default fullcalendar;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Menu/mealCalendar.js